// extracted by mini-css-extract-plugin
module.exports = {"SocialContributionActivities":"SocialContributionActivities_SocialContributionActivities__YsH7d"};